<template>
  <div class="muven-container">
    <div class="muven-router-name-container">
      <p class="muven-router-name">Canais</p>
    </div>

    <div class="muven-content">
      <ChannelEntityListSynchronizationCmp ref="channelEntityListSynchronizationCmp" />
      <ChannelCreationCmp ref="channelCreationCmp" @channelCreated="onChannelCreated()" />
      <Loading page v-if="loadingChannels" />
      <div v-if="!loadingChannels">
        <div class="mb-3">
          <button class="btn btn-outline-primary mr-3" @click="openModalChannelCreation()">Adicionar canal</button>

          <button class="btn btn-outline-secondary" v-show="!this.loadingQueueStatus"
            :disabled="retrievingChannelsStatusSynchronization || loadingQueueStatus" @click="refreshAllQueueStatus()">
            Atualizar status da fila
          </button>
        </div>
        <div class="mb-3" v-if="activeChannels.length">
          <ChannelQueueHealthCmp
            :status-list="queueStatusList"
            :channel-list="channels"
            :loading="loadingQueueStatus" />
        </div>

        <div class="table-responsive">
          <table class="table table-sm table-hover">
            <thead>
              <tr>
                <th>Canal</th>
                <th>Status</th>
                <th>Fila de processamento</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="row in displayRows">
                <tr v-if="row.type === 'inactive-group'" :key="row.key" class="channel-group">
                  <td colspan="4">
                    <button type="button" class="channel-group-toggle"
                      :aria-expanded="showInactive ? 'true' : 'false'"
                      @click="showInactive = !showInactive">
                      <fa icon="chevron-right" class="channel-group-chevron" :class="{ 'is-open': showInactive }" />

                      <span class="channel-group-stack" aria-hidden="true">
                        <ChannelLogoCmp v-for="c in inactiveBrandStack" :key="`stack-${c.enumChannel}`"
                          :channel="c" :size="18" :show-name="false" />
                        <span v-if="inactiveBrandOverflow" class="channel-group-stack-more">+{{ inactiveBrandOverflow }}</span>
                      </span>

                      <span class="channel-group-label">{{ inactiveGroupLabel }}</span>
                      <span class="channel-group-action">{{ showInactive ? 'Ocultar' : 'Mostrar' }}</span>
                    </button>
                  </td>
                </tr>

                <tr v-else :key="row.key" class="channel-row"
                  :class="{ 'is-striped': row.striped, 'is-inactive': !row.channel.isActive, 'is-revealed': row.inGroup }">
                  <td>
                    <ChannelLogoCmp :channel="row.channel" :size="28" :label="row.channel.getRealName()"
                      :caption="row.channel.hasCustomizedName() ? row.channel.name : ''" />
                  </td>
                  <td>
                    <span v-if="row.channel.isActive">
                      <span class="muven-td-icon">
                        <fa icon="check-circle" class="text-success" />
                      </span>
                      <span>Ativo</span>
                    </span>
                    <span v-if="!row.channel.isActive">
                      <span class="muven-td-icon">
                        <fa icon="ban" class="text-muted" />
                      </span>
                      <span>Inativo</span>
                    </span>
                  </td>
                  <td>
                    <!-- Status da fila de processamento -->
                    <span v-if="!row.channel.isActive">
                      <!-- Canal inativo -->
                      <span>
                        <span class="muven-td-icon">
                          <fa icon="ban" class="text-muted" />
                        </span>
                        <span>Paralisado</span>
                      </span>
                    </span>
                    <span v-else>
                      <!-- Canal ativo -->
                      <span v-if="row.channel.queueStatus === 'loading'">
                        <span class="muven-td-icon">
                          <fa icon="spinner" class="text-muted fa-spin" />
                        </span>
                        <span class="text-muted">Calculando...</span>
                      </span>
                      <span v-else-if="row.channel.queueStatus === 'error'">
                        <span class="muven-td-icon">
                          <fa icon="exclamation-triangle" class="text-warning" />
                        </span>
                        <span>Erro ao verificar</span>
                      </span>
                      <span
                        v-else-if="row.channel.queueStatus && row.channel.queueStatus.hasPendingSync && row.channel.queueStatus.hasPendingSync()">
                        <span class="muven-td-icon">
                          <fa icon="sync-alt" class="text-muted fa-spin" />
                        </span>
                        <span>Em andamento</span>
                      </span>
                      <span v-else-if="row.channel.queueStatus">
                        <span class="muven-td-icon">
                          <fa icon="check-circle" class="text-success" />
                        </span>
                        <span>Informações atualizadas</span>
                      </span>
                      <span v-else>
                        <!-- Estado inicial ou indefinido -->
                        <span class="muven-td-icon">
                          <!-- <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i> -->
                          <fa icon="spinner" class="text-muted fa-spin" />

                        </span>
                        <span class="text-muted">Verificando...</span>
                      </span>
                    </span>
                  </td>
                  <td class="text-center muven-td-with-buttons">
                    <button type="button" class="btn btn-default text-muted" data-toggle="dropdown">
                      <fa icon="ellipsis-v" />
                    </button>
                    <div class="dropdown-menu dropdown-menu-right muven-action-menu">
                      <router-link class="dropdown-item"
                        :to="detailUrl(row.channel)">
                        <fa icon="cogs" fixed-width class="muven-action-icon" />
                        <span class="muven-action-label">Configurações</span>
                      </router-link>

                      <router-link class="dropdown-item"
                        :to="channelQueueStatusUrl(row.channel)"
                        target="_blank"
                        rel="noopener"
                        title="Abre em uma nova aba">
                        <fa icon="list-ol" fixed-width class="muven-action-icon" />
                        <span class="muven-action-label">Ir para fila de processamento</span>
                        <fa icon="external-link-alt" class="muven-action-external" />
                      </router-link>

                      <p class="dropdown-divider"></p>

                      <a class="dropdown-item"
                        :href="getAuditUrl(row.channel.id, EntityEnum.Channel)"
                        target="_blank"
                        rel="noopener"
                        title="Abre em uma nova aba">
                        <fa icon="history" fixed-width class="muven-action-icon" />
                        <span class="muven-action-label">Ir para auditoria</span>
                        <fa icon="external-link-alt" class="muven-action-external" />
                      </a>

                      <p class="dropdown-divider"></p>

                      <span class="dropdown-item"
                        @click="openModalChannelEntityListSync(row.channel)">
                        <fa icon="sync-alt" fixed-width class="muven-action-icon" />
                        <span class="muven-action-label">Forçar sincronização</span>
                      </span>

                      <!-- Excluir canal, apenas para canais inativos -->
                      <span class="dropdown-item muven-action-danger"
                        v-if="!row.channel.isActive"
                        @click="openDeleteModal(row.channel)">
                        <fa icon="trash-alt" fixed-width class="muven-action-icon" />
                        <span class="muven-action-label">Excluir canal</span>
                      </span>
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- Modal para confirmação de exclusão -->
    <b-modal ref="deleteModal" @ok="confirmDelete" @hide="resetDeleteForm" @shown="focusInput">
      <template v-slot:modal-title>Confirmação de Exclusão</template>
      <div>
        <p class="text-danger"><strong>ATENÇÃO</strong></p>
        <p>Excluir o canal resultará na perda de todos os dados relacionados a ele. A operação não poderá ser revertida.
        </p>
        <p>Em caso de exclusão acidental, entre em contato com o suporte. Tal ação poderá resultar em custos adicionais.
        </p>
        <p>Para excluir o canal, digite <strong>CONFIRMO</strong> no espaço abaixo.</p>
        <br>
        <b-form-input ref="confirmInput" v-model="confirmText"></b-form-input>
      </div>
      <template v-slot:modal-footer>
        <b-button variant="secondary" @click="closeDeleteModal">Cancelar</b-button>
        <b-button variant="danger" @click="confirmDelete" :disabled="confirmText !== 'CONFIRMO'">Excluir</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>

import { EntityEnum } from '@c2b/muven-commons'
import channelService from '@/channel/services/ChannelService'
import subscriberService from '../../subscriber/services/SubscriberService'
import serviceStatusInformationService from '../../monitoring/services/ServiceStatusInformationService'
import GetAuditUrl from '../../utils/mixins/GetAuditUrl'
import ChannelEntityListSynchronizationCmp from '../components/ChannelEntityListSynchronizationCmp.vue'
import ChannelCreationCmp from '../components/ChannelCreationCmp.vue'
import ChannelLogoCmp from '../components/ChannelLogoCmp.vue'
import ChannelQueueHealthCmp from '../components/ChannelQueueHealthCmp.vue'
import { sortChannelsForList } from '../utils/ChannelListSorter'

// Quantos tipos de canal aparecem empilhados no resumo dos inativos antes do "+N".
const INACTIVE_STACK_LIMIT = 5

export default {
  name: 'ChannelListView',
  components: {
    ChannelEntityListSynchronizationCmp,
    ChannelCreationCmp,
    ChannelLogoCmp,
    ChannelQueueHealthCmp,
  },
  mixins: [
    GetAuditUrl,
  ],
  data() {
    return {
      EntityEnum,
      loadingChannels: true,
      loadingQueueStatus: false,
      retrievingChannelsStatusSynchronization: false,
      channels: [],
      channelsStatusMap: new Map(), // Mapa para status dos canais
      confirmText: '',
      channelToDelete: null,
      queueStatusRefreshPromise: null,
      // Inativos recolhidos por padrão: a lista sempre abre mostrando só o que pede atenção.
      showInactive: false,
    }
  },

  watch: {
    confirmText(newValue) {
      this.confirmText = newValue.toUpperCase();
    },
  },

  methods: {
    async refreshAllQueueStatus() {
      this.retrievingChannelsStatusSynchronization = true;
      this.channels.forEach(channel => {
        if (channel.isActive) {
          this.$set(channel, 'queueStatus', null);
        }
      });

      try {
        // Atualiza todos os status de uma vez
        const newStatuses = await serviceStatusInformationService.getChannelsStatusSynchronization();

        // Atualiza o mapa de status
        const newStatusMap = new Map();
        newStatuses.forEach(status => {
          newStatusMap.set(status.id, status);
        });

        // Atualiza cada canal individualmente
        this.channels.forEach(channel => {
          if (channel.isActive) {
            const status = newStatusMap.get(channel.id);
            if (status) {
              // Adiciona o status ao canal
              this.$set(channel, 'queueStatus', status);
            }
          }
        });

        // Atualiza o mapa global
        this.channelsStatusMap = newStatusMap;

        this.$floatingAlert.success({
          message: 'Informações da fila de processamento atualizadas com sucesso.',
          timeVisible: 10000,
        });
      } catch (err) {
        this.$floatingAlert.error({
          title: 'Oops!',
          message: err.message || 'Houve um problema no momento de obter os status dos canais. Tente novamente mais tarde',
        });

        // Marca canais com erro
        this.channels.forEach(channel => {
          if (channel.isActive && !channel.queueStatus) {
            this.$set(channel, 'queueStatus', 'error');
          }
        });
      } finally {
        this.retrievingChannelsStatusSynchronization = false;
      }
    },

    async loadQueueStatusForChannel(channel) {
      if (!channel.isActive) {
        return;
      }

      // Marca como carregando
      this.$set(channel, 'queueStatus', 'loading');

      try {
        // Carrega status individual (ou em lote otimizado)
        const statuses = await serviceStatusInformationService.getChannelsStatusSynchronization();
        const channelStatus = statuses.find(s => s.id === channel.id);

        if (channelStatus) {
          this.$set(channel, 'queueStatus', channelStatus);
          this.channelsStatusMap.set(channel.id, channelStatus);
        } else {
          this.$set(channel, 'queueStatus', null);
        }
      } catch (error) {
        this.$set(channel, 'queueStatus', 'error');
      }
    },

    async loadQueueStatusInBackground() {
      if (this.loadingQueueStatus) {
        return;
      }

      this.loadingQueueStatus = true;

      try {
        // Carrega todos os status de uma vez (mais eficiente que individualmente)
        const statuses = await serviceStatusInformationService.getChannelsStatusSynchronization();

        // Cria um mapa para acesso rápido
        const statusMap = new Map();
        statuses.forEach(status => {
          statusMap.set(status.id, status);
        });

        // Atualiza cada canal com seu status
        this.channels.forEach(channel => {
          if (channel.isActive) {
            const status = statusMap.get(channel.id);
            if (status) {
              this.$set(channel, 'queueStatus', status);
            } else {
              this.$set(channel, 'queueStatus', null);
            }
          }
        });

        // Armazena o mapa para uso futuro
        this.channelsStatusMap = statusMap;

      } catch (error) {
        // Marca os canais com erro
        this.channels.forEach(channel => {
          if (channel.isActive && !channel.queueStatus) {
            this.$set(channel, 'queueStatus', 'error');
          }
        });
      } finally {
        this.loadingQueueStatus = false;
      }
    },

    onChannelCreated() {
      this._loadChannels()
    },
    openModalChannelEntityListSync(channel) {
      this.$refs.channelEntityListSynchronizationCmp.show(channel)
    },
    openModalChannelCreation() {
      this.$refs.channelCreationCmp.openModal()
    },
    goto(channel) {
      this.$router.push(`/canais/${channel.id}/configuracoes`)
    },
    async _loadChannels() {
      try {
        this.loadingChannels = true;

        // Passo 1: Carrega apenas os canais (rápido)
        this.channels = await channelService.getChannels();
        this.loadingChannels = false;

        // Sem nenhum ativo, um grupo fechado deixaria a tela só com a linha de resumo.
        this.showInactive = this.activeChannels.length === 0;

        // Passo 2: Inicia o carregamento dos status em background
        this.loadQueueStatusInBackground();

      } catch (e) {
        this.$floatingAlert.error({
          message: e.message,
        });
        this.loadingChannels = false;
      }
    },

    focusInput() {
      (this.$refs.confirmInput).focus();
    },

    openDeleteModal(channel) {
      this.channelToDelete = channel;
      this.$refs.deleteModal.show();
    },
    closeDeleteModal() {
      this.$refs.deleteModal.hide();
    },

    async confirmDelete() {
      if (this.confirmText === 'CONFIRMO' && this.channelToDelete) {
        try {
          this.loadingChannels = true;

          const channelId = this.channelToDelete.id;

          this.resetDeleteForm();
          this.closeDeleteModal();

          await channelService.deleteChannel(channelId)
          this.channels = this.channels.filter(ch => ch.id !== channelId)
          this.$floatingAlert.success({
            message: 'Canal excluído com sucesso.',
            timeVisible: 10000,
          });
        } catch (e) {
          this.$floatingAlert.error({
            message: e.message,
          });
        } finally {
          this.loadingChannels = false;
        }
      }
    },

    resetDeleteForm() {
      this.channelToDelete = null;
      this.confirmText = '';
    },
  },
  async mounted() {
    await this._loadChannels();
  },
  computed: {
    sortedChannels() {
      return sortChannelsForList(this.channels)
    },
    activeChannels() {
      return this.sortedChannels.filter(c => c.isActive)
    },
    // Lido de channel.queueStatus (gravado com $set), e não do channelsStatusMap: Map não é reativo no Vue 2.
    queueStatusList() {
      return this.activeChannels
        .map(c => c.queueStatus)
        .filter(status => status && typeof status === 'object')
    },
    inactiveChannels() {
      return this.sortedChannels.filter(c => !c.isActive)
    },
    // Recolhe qualquer inativo, mesmo um só - exceto quando ele é o único canal
    // da conta: esconder o único item deixaria a lista vazia.
    groupInactive() {
      return this.channels.length > 1 && this.inactiveChannels.length > 0
    },
    inactiveGroupLabel() {
      const count = this.inactiveChannels.length

      return count === 1 ? '1 canal inativo' : `${count} canais inativos`
    },
    inactiveBrands() {
      const seen = new Set()

      return this.inactiveChannels.filter(c => {
        if (seen.has(c.enumChannel)) {
          return false
        }

        seen.add(c.enumChannel)
        return true
      })
    },
    inactiveBrandStack() {
      return this.inactiveBrands.slice(0, INACTIVE_STACK_LIMIT)
    },
    inactiveBrandOverflow() {
      return Math.max(0, this.inactiveBrands.length - INACTIVE_STACK_LIMIT)
    },
    /*
     * Linhas na ordem em que a tabela desenha. O zebrado é calculado aqui, por
     * bloco: o nth-of-type do Bootstrap contaria a linha do grupo e inverteria
     * as faixas dos inativos.
     */
    displayRows() {
      const toRows = (channels, inGroup) => channels.map((channel, index) => ({
        type: 'channel',
        key: `channel-${channel.id || index}`,
        channel,
        striped: index % 2 === 0,
        inGroup,
      }))

      if (!this.groupInactive) {
        return toRows([...this.activeChannels, ...this.inactiveChannels], false)
      }

      return [
        ...toRows(this.activeChannels, false),
        {type: 'inactive-group', key: 'inactive-group'},
        ...(this.showInactive ? toRows(this.inactiveChannels, true) : []),
      ]
    },
    hasMoreThanOneChannel() {
      return this.channels.length > 1
    },
    detailUrl() {
      return (channel) => {
        return `/canais/${channel.id}/configuracoes`
      }
    },
    channelQueueStatusUrl() {
      return (channel) => {
        return `/canais/${channel.id}/configuracoes/informacoes/fila-processamento`
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/utils/styles/constants.scss';

$inactive-content-opacity: .55;

// Zebrado próprio (ver displayRows): a table-striped foi removida.
.channel-row.is-striped {
  background-color: color-mix(in srgb, var(--text-strong) 3%, transparent);
}

.channel-row:hover {
  background-color: color-mix(in srgb, var(--text-strong) 7.5%, transparent);
}

/*
 * Inativos: apagados, mas legíveis. Só as células de conteúdo perdem força - a
 * coluna de ações continua com contraste de controle clicável, porque é dela
 * que sai "Excluir canal".
 */
.channel-row.is-inactive {
  td:not(:last-child) {
    opacity: $inactive-content-opacity;
    transition: opacity .15s ease-in-out;
  }

  // Grayscale não altera o texto (já é preto/cinza), só tira a cor da marca.
  .channel-logo {
    filter: grayscale(.7);
  }

  &:hover td:not(:last-child) {
    opacity: .85;
  }
}

// Entrada das linhas ao abrir o grupo. Só opacidade: animar altura de <tr> não funciona.
.channel-row.is-revealed {
  animation: channel-row-reveal .18s ease-out;
}

@keyframes channel-row-reveal {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.channel-group {
  td {
    padding: 0;
    // Separa os inativos dos ativos com um pouco mais de peso que as bordas das linhas.
    border-top: 2px solid var(--tint-brand-border);
    background-color: var(--surface-2);
  }

  // O hover da tabela não pode apagar o fundo do resumo; o hover é do botão.
  &:hover td {
    background-color: var(--surface-2);
  }
}

.channel-group-toggle {
  appearance: none;
  -webkit-appearance: none;
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 9px 12px;
  border: 0;
  background-color: transparent;
  color: var(--text-muted);
  text-align: left;
  cursor: pointer;
  transition: background-color .15s ease-in-out;

  &:hover {
    background-color: color-mix(in srgb, #{$color-primary} 5%, transparent);

    .channel-group-action {
      text-decoration: underline;
    }
  }

  &:focus {
    outline: 0;
  }

  &:focus-visible {
    box-shadow: inset 0 0 0 2px color-mix(in srgb, #{$color-primary} 35%, transparent);
  }
}

.channel-group-chevron {
  width: 10px;
  font-size: .75em;
  color: var(--text-faint);
  transition: transform .18s ease-in-out;

  &.is-open {
    transform: rotate(90deg);
  }
}

// Pilha de marcas: dá para saber quais canais estão ali sem abrir o grupo.
.channel-group-stack {
  display: inline-flex;
  align-items: center;

  .channel-logo {
    // Contorno da cor do fundo: separa um ícone do outro na sobreposição.
    // Mesmo raio do tile de 18px (ver ChannelLogoCmp), senão os cantos vazam do contorno.
    border-radius: 4px;
    box-shadow: 0 0 0 2px var(--surface-2);
    // Mais viva que as linhas inativas: aqui o ícone é a única pista de quais canais estão no grupo.
    filter: grayscale(.5);
    opacity: .9;

    & + .channel-logo {
      margin-left: -3px;
    }
  }
}

.channel-group-stack-more {
  margin-left: 6px;
  font-size: .8em;
  font-weight: 600;
  color: var(--text-faint);
}

.channel-group-label {
  font-weight: 600;
}

.channel-group-action {
  margin-left: auto;
  color: $color-primary;
  font-size: .9em;
  font-weight: 600;
}
</style>
